import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer';
import { FormProvider } from 'react-hook-form';
import Summary from './components/Summary';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';
import DisplayErrorMessage from '@@viewCommonComponents/displayer/DisplayErrorMessage';
import useSouscriptionRecapForm from './hooks/useSouscriptionRecapForm.jsx';
import { includes, pathOr, propOr } from 'ramda';
import DownloadDocumentsContainer from '@@viewCommonComponents/displayer/DownloadDocumentsContainer';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import { Icon } from '@fasstech/middle-design-system';
import React from 'react';

const SouscriptionRecapForm = ({
  getMiddleText,
  getMiddleBoolean,
  middleFeatures,
  project,
  regimeObligatoire,
  familySituations,
  jobs,
  professionalSituations,
  socioProfessionalCategories,
  activities,
  viewMode,
  usersInformation
}) => {
  const customer = propOr({}, 'customer', project);
  const grantees = propOr([], 'grantees', project);
  const prevTnsCommission = propOr({}, 'prevTnsCommission', project);

  const {
    onSubmit,
    methods,
    downloadMutation,
    sendEmailMutation,
    displayError,
    isProjectEditable,
    $onPrevClick,
    onProjectNotEditable,
    editDetails,
    editSouscription3,
    customerCardOptions,
    isDutyOfAdviceSkipped,
    offerCode,
    guarantees,
    PTIADeathGuarantees,
    spousePensionGuarantees,
    educationPensionGuarantees,
    disabilityGuarantees,
    invalidityGuarantees,
    displayRefundInformation,
    granteesCardOptions,
    editContract,
    canGoNext,
    setCanSendMail,
    canSendMail
  } = useSouscriptionRecapForm({
    regimeObligatoire,
    jobs,
    professionalSituations,
    familySituations,
    socioProfessionalCategories,
    activities,
    getMiddleText,
    getMiddleBoolean,
    project
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <PageLayout
          withFormLayout={false}
          className={'flex flex-col items-center w-full gap-y-6'}
        >
          <div className="md:w-[1220px] w-[100%]">
            {project && (
              <Summary
                project={project}
                getMiddleText={getMiddleText}
                getMiddleBoolean={getMiddleBoolean}
                editDetails={editDetails}
                editSouscription3={editSouscription3}
                customerCardOptions={customerCardOptions}
                isDutyOfAdviceSkipped={isDutyOfAdviceSkipped}
                middleFeatures={middleFeatures}
                offerCode={offerCode}
                guarantees={guarantees}
                PTIADeathGuarantees={PTIADeathGuarantees}
                spousePensionGuarantees={spousePensionGuarantees}
                educationPensionGuarantees={educationPensionGuarantees}
                disabilityGuarantees={disabilityGuarantees}
                invalidityGuarantees={invalidityGuarantees}
                regimeObligatoire={regimeObligatoire}
                displayRefundInformation={displayRefundInformation}
                grantees={[customer, ...grantees]}
                granteesCardOptions={granteesCardOptions}
                editContract={editContract}
                viewMode={viewMode}
                prevTnsCommission={
                  includes('BROKER', usersInformation[0].roles) &&
                  prevTnsCommission
                }
              />
            )}

            <div className={'flex flex-col items-center gap-4 py-6'}>
              <Icon name={'circleClosedFile'} size={50} />
              <DownloadDocumentsContainer
                downloadMutation={downloadMutation}
                documentsList={propOr([], 'documentsToDownload', project)}
                sendEmailMutation={sendEmailMutation}
                userEmail={pathOr('', ['user', 'emails', 0, 'value'], project)}
                customerEmail={pathOr(
                  '',
                  ['customer', 'emails', 0, 'value'],
                  project
                )}
                customerCivility={pathOr('', ['customer', 'civility'], project)}
                customerLastName={pathOr('', ['customer', 'lastName'], project)}
                userFirstName={pathOr('', ['user', 'firstName'], project)}
                userLastName={pathOr('', ['user', 'lastName'], project)}
                getMiddleText={getMiddleText}
                downloadMandatory={false}
                setCanSendMail={setCanSendMail}
                canSendMail={canSendMail}
              />
            </div>

            {isNotNilOrEmpty(displayError) && (
              <DisplayErrorMessage text={displayError} />
            )}
          </div>
        </PageLayout>

        <ButtonContainer
          $onPreviousButtonClick={
            isProjectEditable ? $onPrevClick : onProjectNotEditable
          }
          getMiddleText={getMiddleText}
          nextButtonLabel={getMiddleText(
            'GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL'
          )}
          displayResumeButton
          nextButtonIsDisabled={!canGoNext}
        />
      </form>
    </FormProvider>
  );
};

export default SouscriptionRecapForm;
